//import logo from './logo.svg';
import './App.css';
import './WZanalysis/WZanalysis.css';

import FDOTHeader from './FdotHeader';
import FDOTFooter from './FdotFooter';
import { useState, lazy, Suspense } from 'react';

import { FileHashContext } from './file_hash_context';
const WZanalysis = lazy(() => import('./WZanalysis'));

function App() {
  const [iconList, setIconList] = useState([]);
  const [fileHash, setFileHash] = useState('...');
  return (
    <FileHashContext.Provider value={{ fileHash, setFileHash }}>
      <div>
      {(process.env.REACT_DRAFT==="yes") && <div className="watermark">DRAFT</div>}
        <FDOTHeader
          Title="Work Zone Lane Closure Analysis"
          Department="State Traffic Services"
          IconList={iconList}
        />
        <Suspense
          fallback={
            <div className="content">
              <div
                className="map noSegmentSelected"
                style={{ padding: '20px' }}
              >
                Loading
              </div>
              <div
                className="analysis noSegmentSelected"
                style={{ width: '300px' }}
              >
                <p>Please Select a Segment</p>
                <br />
                <p>Loading</p>
              </div>
            </div>
          }
        >
          <WZanalysis setIconList={setIconList} />
        </Suspense>
        <FDOTFooter ccyear="2022" />
      </div>
    </FileHashContext.Provider>
  );
}

export default App;
